const parseWarehouseItemId = value => {
  const warehouseItemId = Number(value);
  return Number.isInteger(warehouseItemId) && warehouseItemId > 0
    ? warehouseItemId
    : null;
};

const getWarehouseItemIdFromValues = values =>
  parseWarehouseItemId(values?.item?.id ?? values?.id);

const getWarehouseItemDetailsUrl = (values, search = "") => {
  const warehouseItemId = getWarehouseItemIdFromValues(values);
  if (warehouseItemId == null) return "/warehouse";

  const queryParams = new URLSearchParams(search);
  if (!queryParams.has("status")) queryParams.set("status", "all");

  return `${warehouseItemId}/details?${queryParams.toString()}`;
};

const buildWarehouseNavigationTargetUrl = ({
  activeSubPage = "details",
  listContext = {},
  recordId,
  status = "all",
} = {}) => {
  const query = new URLSearchParams(listContext.locationSearch || "");
  query.set("status", status || query.get("status") || "all");
  return `/warehouse/${recordId}/${activeSubPage}?${query.toString()}`;
};

export {
  buildWarehouseNavigationTargetUrl,
  getWarehouseItemDetailsUrl,
  getWarehouseItemIdFromValues,
  parseWarehouseItemId,
};
